/*
 * @Description: 
 * @Version: 2.0
 * @Autor: sen.yang
 * @Date: 2022-04-08 10:52:32
 * @LastEditors: sen.yang
 * @LastEditTime: 2022-04-08 14:48:40
 */
import request from '../../utils/request'
import server from './config'
export default {
    /**
     * 签到
     */
    sign:(data)=>{
        return request({
            url:`${server.MS_PATIENT_CONSUMMER}/meeting/1/sign`,
            method: 'post',
            data,
        })
    },
    isSign:(data)=>{
        return request({
            url:`${server.MS_PATIENT_CONSUMMER}/meeting/1/isSign`,
            method: 'post',
            data,
        })
    },
    isCeiling:(data)=>{
        return request({
            url:`${server.MS_PATIENT_CONSUMMER}/meeting/1/isCeiling`,
            method: 'post',
            data,
        })
    },
}



// WEBPACK FOOTER //
// ./src/api/modules/meeting.js